import { useState } from "react";
import "./Timeline.css";

const timelineData = [
  { 
    year: "1991", 
    title: "Foundation", 
    description: "Establishment of SCOPE Company by Dr. Mehmet Haydar, marking the foundation of ADAM Holding Union.",
    icon: "🏛️"
  },
  { 
    year: "1995", 
    title: "Expansion", 
    description: "Expansion into multi-disciplinary EPC services, including engineering, consulting, and project management.",
    icon: "📈"
  },
  { 
    year: "2000", 
    title: "Global Reach", 
    description: "Opening of international offices in Bahrain and Saudi Arabia.",
    icon: "🌍"
  },
  { 
    year: "2010", 
    title: "Major Projects", 
    description: "Execution of major infrastructure and energy projects across Africa and the Middle East.",
    icon: "🏗️"
  },
  { 
    year: "2015", 
    title: "Diversification", 
    description: "Diversification into education, technology, and commerce sectors.",
    icon: "🔄"
  },
  { 
    year: "2018", 
    title: "Leadership", 
    description: "Recognition as a leader in EPCM services, with multiple large-scale projects completed globally.",
    icon: "👑"
  },
  { 
    year: "2020", 
    title: "Innovation", 
    description: "Adoption of smart construction technologies and renewable energy solutions.",
    icon: "💡"
  },
  { 
    year: "2023", 
    title: "Digital Growth", 
    description: "Expansion into digital learning platforms and enhanced global partnerships.",
    icon: "📱"
  },
  { 
    year: "2025", 
    title: "Adam Holding Union", 
    description: "Opening of a new headquarters in Istanbul and strategic investments in renewable energy projects and technological advancements.",
    icon: "🚀"
  },
];

const Timeline = () => {
  const [activeItem, setActiveItem] = useState(null);

  const handleItemClick = (index) => {
    setActiveItem(activeItem === index ? null : index);
  };

  return (
    <div className="about-timeline-container">
      <div className="about-timeline">
        {timelineData.map((item, index) => (
          <div 
            key={index} 
            className={`about-timeline-item ${index % 2 === 0 ? 'about-timeline-item--left' : 'about-timeline-item--right'}`}
          >
            {/* Timeline Connector */}
            <div className="about-timeline-connector">
              <div className="about-timeline-line"></div>
              <div 
                className={`about-timeline-dot ${activeItem === index ? 'about-timeline-dot--active' : ''}`}
                onClick={() => handleItemClick(index)}
              >
                <span className="about-timeline-dot-icon">{item.icon}</span>
              </div>
            </div>

            {/* Timeline Content */}
            <div className="about-timeline-content">
              <div className="about-timeline-year">{item.year}</div>
              <div className="about-timeline-card">
                <div className="about-timeline-card-header">
                  <span className="about-timeline-card-icon">{item.icon}</span>
                  <h3 className="about-timeline-card-title">{item.title}</h3>
                </div>
                <p className="about-timeline-card-description">{item.description}</p>
                <button 
                  className="about-timeline-card-button"
                  onClick={() => handleItemClick(index)}
                >
                  {activeItem === index ? 'Show Less' : 'Read More'}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Active Item Detail Modal */}
      {activeItem !== null && (
        <div className="about-timeline-modal">
          <div className="about-timeline-modal-content">
            <div className="about-timeline-modal-header">
              <span className="about-timeline-modal-icon">{timelineData[activeItem].icon}</span>
              <div>
                <h2 className="about-timeline-modal-year">{timelineData[activeItem].year}</h2>
                <h3 className="about-timeline-modal-title">{timelineData[activeItem].title}</h3>
              </div>
              <button 
                className="about-timeline-modal-close"
                onClick={() => setActiveItem(null)}
              >
                ×
              </button>
            </div>
            <div className="about-timeline-modal-body">
              <p>{timelineData[activeItem].description}</p>
              <div className="about-timeline-modal-achievements">
                <h4>Key Achievements:</h4>
                <ul>
                  <li>Strategic milestone in company growth</li>
                  <li>Expansion into new markets</li>
                  <li>Innovation in service delivery</li>
                </ul>
              </div>
            </div>
            <div className="about-timeline-modal-footer">
              <button 
                className="about-timeline-modal-button about-timeline-modal-button--secondary"
                onClick={() => setActiveItem(null)}
              >
                Close
              </button>
              {activeItem > 0 && (
                <button 
                  className="about-timeline-modal-button about-timeline-modal-button--primary"
                  onClick={() => setActiveItem(activeItem - 1)}
                >
                  Previous
                </button>
              )}
              {activeItem < timelineData.length - 1 && (
                <button 
                  className="about-timeline-modal-button about-timeline-modal-button--primary"
                  onClick={() => setActiveItem(activeItem + 1)}
                >
                  Next
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Timeline;